<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Sip Agent'" style="height: 100%">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllAgent"
                />
                <label for="idSelectAllAgent"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in uniqueSipAgent"
              :key="row.proxyServer"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectSipAgent'"
                  />
                  <label :for="'idRowSelectSipAgent'"></label>
                </div>
              </td>
              <td>
                <div>{{ uniqueSipAgent[0].proxyServer }}</div>
              </td>
              <td>
                <div>{{ uniqueSipAgent[0].registrarServer }}</div>
              </td>
              <td>
                <div>{{ uniqueSipAgent[0].outboundProxy }}</div>
              </td>
              <td>
                <div>{{ uniqueSipAgent[0].signalPort }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Sip Agent Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="proxyserver"
                  >Proxy Server</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'server',
                      sipAgentForm.proxyServer
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="proxyserver"
                    v-model="sipAgentForm.proxyServer"
                    placeholder="STRING<1-64>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'server',
                        sipAgentForm.proxyServer
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("server", sipAgentForm.proxyServer) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="registrarServer"
                  >Registrar Server</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'server',
                      sipAgentForm.registrarServer
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="registrarServer"
                    v-model="sipAgentForm.registrarServer"
                    placeholder="STRING<1-64>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'server',
                        sipAgentForm.registrarServer
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("server", sipAgentForm.registrarServer)
                    }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="outboundProxy"
                  >Outbound Proxy</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'server',
                      sipAgentForm.outboundProxy
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="outboundProxy"
                    v-model="sipAgentForm.outboundProxy"
                    placeholder="STRING<1-64>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'server',
                        sipAgentForm.outboundProxy
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("server", sipAgentForm.outboundProxy) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="signalPort"
                  >Signal Port</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'port',
                      sipAgentForm.signalPort
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="signalPort"
                    v-model="sipAgentForm.signalPort"
                    placeholder="INTEGER<1-65535>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('port', sipAgentForm.signalPort)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("port", sipAgentForm.signalPort) }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import en from "./../lang/en-US.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueSipAgent",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["ontIndex"],

  data() {
    return {
      title: "",
      uniqueSipAgent: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      sipAgentForm: {
        proxyServer: "",
        outboundProxy: "",
        registrarServer: "",
        signalPort: "",
      },
    }
  },

  created() {
    this.loaduniqueSipAgent()
  },

  methods: {
    loaduniqueSipAgent() {
      get("uniqueSipAgent?ontIndex=" + this.ontIndex)
        .then((res) => {
          this.title = res.data.title
          this.uniqueSipAgent = res.data.data
        })
        .catch((err) => {
          this.title = en.uniqueAgentTable.title
          this.uniqueSipAgent = en.uniqueAgentTable.data
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },
    clkEdit() {
      for (let i = 0; i < this.uniqueSipAgent.length; i++) {
        if (this.uniqueSipAgent[i].selected == true) {
          this.sipAgentForm.proxyServer = this.uniqueSipAgent[0].proxyServer
          this.sipAgentForm.outboundProxy = this.uniqueSipAgent[0].outboundProxy
          this.sipAgentForm.registrarServer =
            this.uniqueSipAgent[0].registrarServer
          this.sipAgentForm.signalPort = this.uniqueSipAgent[0].signalPort
          this.isShowAddTable = true
        }
      }
    },

    clkDel() {
      var delData = {}

      if (this.uniqueSipAgent[0].selected == true) {
        delData["ontIndex"] = this.ontIndex
        post("uniqueSipAgentDelete", delData)
          .then((res) => {
            if (
              res.data == undefined ||
              res.data.code === undefined ||
              res.data.code === 0
            ) {
              this.loaduniqueSipAgent()
              this.showAlertBox("info", "Info", "Delete Successful!")
            } else this.showAlertBox("warn", "Message", res.data.msg)
          })
          .catch((err) => {
            this.showAlertBox("critical", "error", err)
          })
      }
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var sipAgentFormTmp = {
        proxyServer: "",
        outboundProxy: "",
        registrarServer: "",
        signalPort: "",
      }
      this.sipAgentForm = sipAgentFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.uniqueSipAgent.length; i++) {
        if (this.isSelectAll) {
          this.uniqueSipAgent[i].selected = true
        } else {
          this.uniqueSipAgent[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.uniqueSipAgent.length; i++) {
        this.uniqueSipAgent[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var sipAgentConfig = {
        ontIndex: this.ontIndex,
        proxyServer: this.sipAgentForm.proxyServer,
        outboundProxy: this.sipAgentForm.outboundProxy,
        registrarServer: this.sipAgentForm.registrarServer,
        signalPort: Number(this.sipAgentForm.signalPort),
      }

      if (
        this.sipAgentForm.proxyServer == "" ||
        this.checkParameters("server", this.sipAgentForm.proxyServer)
      ) {
        this.showAlertBox("warn", "Message", "Invalid proxy server")
        return
      }
      if (
        this.sipAgentForm.outboundProxy != "" &&
        this.checkParameters("server", this.sipAgentForm.outboundProxy)
      ) {
        this.showAlertBox("warn", "Message", "Invalid outbound proxy")
        return
      }
      if (
        this.sipAgentForm.registrarServer != "" &&
        this.checkParameters("server", this.sipAgentForm.registrarServer)
      ) {
        this.showAlertBox("warn", "Message", "Invalid registrar proxy")
        return
      }
      if (this.sipAgentForm.signalPort == "") {
        sipAgentConfig.signalPort = -1
      } else if (this.checkParameters("port", this.sipAgentForm.signalPort)) {
        this.showAlertBox("warn", "Message", "Invalid signal port")
        return
      }

      post("uniqueSipAgentConfig", sipAgentConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipAgent()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "server") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 64
        ) {
          return "invalid server"
        }
      } else if (type == "port") {
        if (
          isNaN(Number(value)) ||
          Number(value) < 1 ||
          Number(value) > 65535
        ) {
          return "port number must be in range 1-65535"
        }
      }
      return null
    },
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
